import {
  createConfig,
  getConfigs,
  getConfigByTypeKey,
  updateConfig,
  deleteConfig,
} from "./configurationService";
import { getUserName } from "./auth";

let _templateType = null;

// get the user
const getTemplateType = async () => {
  if (!_templateType) {
    const userName = await getUserName();
    _templateType = `personal-prompt-template--${userName}`;
  }
  return _templateType;
};

const viewScope = ["owner"];
const editScope = ["owner"];
const deleteScope = ["owner"];

export const personalTemplateService = {
  createTemplate: async (key, value) => {
    return await createConfig(
      await getTemplateType(),
      key,
      value,
      null,
      null,
      viewScope,
      editScope,
      deleteScope
    );
  },

  getAllTemplates: async () => {
    return await getConfigs(await getTemplateType());
  },

  getTemplate: async (key, throw404 = false) => {
    try {
      return await getConfigByTypeKey(await getTemplateType(), key);
    } catch (e) {
      if (throw404 && e.response && e.response.status === 404) {
        throw e;
      }
      return null;
    }
  },

  updateTemplate: async (key, templateValue) => {
    const template = await getConfigByTypeKey(await getTemplateType(), key);
    return await updateConfig(
      template.id,
      await getTemplateType(),
      template.key,
      templateValue
    );
  },

  deleteTemplate: async (key) => {
    const template = await getConfigByTypeKey(await getTemplateType(), key);
    return await deleteConfig(template.id);
  },

  duplicateTemplate: async (key) => {
    const template = await getConfigByTypeKey(await getTemplateType(), key);
    if (template) {
      const duplicate = {
        ...template.value,
        name: `Copy of ${template.value.name}`,
      };
      return await createConfig(await getTemplateType(), duplicate);
    }
    return null;
  },
};

export default personalTemplateService;
